const installmentQueryBuilder = require('./installments-query-builder')

const installments = `
installments AS (
  ${installmentQueryBuilder({instalmentTableJoin: true, isActiveClause: true, includeBalance: false})}
)
`

module.exports = installments
